import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { TextFieldWrapper, TextInput } from './TextField.styles';
import { ClearIcon } from '../../Icon';
export const TextField = ({ value, setValue, state, className, onChange, onFocus, onBlur, name, ...props }) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleChange = useCallback((e) => {
        if (setValue) {
            setValue(e.target.value);
        }
        if (onChange) {
            onChange(e);
        }
    }, [setValue, onChange]);
    const handleClear = useCallback(() => {
        if (setValue) {
            setValue('');
        }
        if (onChange) {
            const event = {
                target: {
                    value: '',
                    name,
                },
            };
            onChange(event);
        }
    }, [setValue, onChange, name]);
    const handleFocus = useCallback((e) => {
        setIsFocused(true);
        if (onFocus) {
            onFocus(e);
        }
    }, [onFocus]);
    const handleBlur = useCallback((e) => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    }, [onBlur]);
    return (_jsxs(TextFieldWrapper, { className: className, "$isFocused": isFocused, "$state": state, children: [_jsx(TextInput, { type: "text", value: value, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, name: name, ...props }), value && (_jsx(ClearIcon, { onClick: handleClear, style: {
                    marginLeft: '12px',
                    cursor: 'pointer',
                }, "aria-label": "Clear input" }))] }));
};
//# sourceMappingURL=TextField.js.map